import { domains } from '@/utils/domains'
import { useSlug } from '@/hooks'
import { useLocation } from 'react-router'

export function usePages() {
  const location = useLocation()
  const slug = useSlug()
  const isCustomDomain = domains[window.location.hostname] !== undefined

  // Custom domains serve the ecommerce at the root; slug domains nest it under /:slug.
  const base = isCustomDomain ? '' : `/${slug}`

  const pages = {
    Landing: base || '/',
    ProcessSelection: `${base}/select`,
    ItemSelection: `${base}/order`,
    ItemOptions: `${base}/order/item-options`,
    RefundMethod: `${base}/refund-method`,
    ReturnAddress: `${base}/return-address`,
    ReturnMethod: `${base}/return-method`,
    Confirmation: `${base}/confirm`,
    SuccessTracking: `${base}/success-tracking`,
    Error: `${base}/error`,
    Tracking: `${base}/tracking`,
    CoverCancellation: `${base}/cover-cancellation`,
    Withdrawal: `${base}/withdrawal`
  }

  const findCurrentPage = () => {
    switch (location.pathname) {
      case pages.Landing:
        return 'Landing'
      case pages.ItemSelection:
        return 'ItemSelection'
      case pages.ItemOptions:
        return 'ItemOptions'
      case pages.RefundMethod:
        return 'RefundMethod'
      case pages.ReturnAddress:
        return 'ReturnAddress'
      case pages.ReturnMethod:
        return 'ReturnMethod'
      case pages.Confirmation:
        return 'Confirmation'
      case pages.SuccessTracking:
        return 'SuccessTracking'
      case pages.Error:
        return 'Error'
      case pages.Tracking:
        return 'Tracking'
      case pages.ProcessSelection:
        return 'ProcessSelection'
      case pages.CoverCancellation:
        return 'CoverCancellation'
      case pages.Withdrawal:
        return 'Withdrawal'
      default:
        return 'Landing'
    }
  }

  const currentPage = findCurrentPage()

  return { pages, currentPage }
}
